<p-dialog header="Розподіл платежу по рахунках" [visible]="display" [modal]="true"
          [closable]="phase !== 'running'" [closeOnEscape]="phase !== 'running'"
          [style]="{width: '70vw'}" (visibleChange)="onVisibleChange($event)">

  <ng-container *ngIf="row">
    <div class="split-summary">
      <strong>{{row.counterparty_name}}</strong>
      · {{row.booking_date | date:'dd.MM.yyyy'}}
      · <strong>{{row.amount_decimal | number:'1.2-2'}} {{row.currency_code}}</strong>
      <span *ngIf="row.counterparty_edrpou"> · ЄДРПОУ {{row.counterparty_edrpou}}</span>
      <div class="split-remittance" *ngIf="row.remittance_text">{{row.remittance_text}}</div>
    </div>

    <p class="split-hint" *ngIf="phase === 'edit'">
      Показано недавні відкриті рахунки контрагента: спершу пропозиція агента, далі відвантажені, але не сплачені
      (жирним), потім решта. Старіший рахунок додайте вручну нижче.
      Платіж створюється окремо для кожного відміченого рахунку. Залишок і суми платежів вказано у валюті
      транзакції; «Валюта рахунку» лише інформує, у якій валюті виписано рахунок.
    </p>

    <div class="split-message split-message--error" *ngIf="loadError">{{loadError}}</div>
    <div class="split-message split-message--error" *ngIf="currencyBlockMessage">{{currencyBlockMessage}}</div>

    <p-table [value]="lines" [loading]="loading" dataKey="key" styleClass="p-datatable-gridlines p-datatable-sm split-table">
      <ng-template pTemplate="header">
        <tr>
          <th class="split-col-check"><span class="split-sr-only">Обрати рахунок</span></th>
          <th>Рахунок</th>
          <th class="split-col-date">Дата</th>
          <th>Клієнт</th>
          <th class="split-col-num">Залишок</th>
          <th class="split-col-num">Відвантажено</th>
          <th class="split-col-cur">Валюта рахунку</th>
          <th class="split-col-amount">Сплатити</th>
          <th class="split-col-pct" pTooltip="Частка поточного платежу від повної суми рахунку">% від суми</th>
          <th *ngIf="phase !== 'edit'">Стан</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-line let-i="rowIndex">
        <tr>
          <td class="split-col-check">
            <p-checkbox [binary]="true" [(ngModel)]="line.checked"
                        [inputId]="'split-check-' + line.key"
                        [ariaLabel]="'Обрати рахунок ' + line.documentNumber"
                        [disabled]="phase !== 'edit' || !!currencyBlockMessage"
                        (onChange)="onCheckChange(line)"></p-checkbox>
          </td>
          <td>
            {{line.documentNumber}}
            <p-tag *ngIf="line.isSuggested" value="Пропозиція агента" severity="info" styleClass="ml-2"></p-tag>
            <p-tag *ngIf="line.manual" value="Додано вручну" severity="secondary" styleClass="ml-2"></p-tag>
          </td>
          <td class="split-col-date">{{line.documentDate | date:'dd.MM.yyyy'}}</td>
          <td>{{line.clientName}}</td>
          <td class="split-col-num">{{line.outstanding | number:'1.2-2'}}</td>
          <td class="split-col-num" [class.split-shipped--unpaid]="line.shippedUnpaid">
            <ng-container *ngIf="line.shippedSum !== null; else noShipped">{{line.shippedSum | number:'1.2-2'}}</ng-container>
            <ng-template #noShipped>—</ng-template>
          </td>
          <td class="split-col-cur">
            {{line.currencyCode || '—'}}
          </td>
          <td class="split-col-amount">
            <ng-container>
              <p-inputNumber [ngModel]="line.amount" (ngModelChange)="onAmountChange(line, $event)"
                             mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
                             [ariaLabel]="'Сума до сплати за рахунком ' + line.documentNumber"
                             [disabled]="phase !== 'edit' || !line.checked"
                             [inputStyleClass]="'split-amount-input' + (validation.lineErrors[i] ? ' ng-invalid ng-dirty' : '')"></p-inputNumber>
              <div class="split-line-error" *ngIf="line.checked && validation.lineErrors[i]">{{validation.lineErrors[i]}}</div>
            </ng-container>
          </td>
          <td class="split-col-pct">
            <ng-container *ngIf="percentOf(line) !== null; else noPercent">{{percentOf(line) | number:'1.0-1'}}%</ng-container>
            <ng-template #noPercent>—</ng-template>
          </td>
          <td *ngIf="phase !== 'edit'" class="split-status">
            <ng-container [ngSwitch]="line.status">
              <span *ngSwitchCase="'created'" class="split-status--ok">
                <i class="pi pi-check"></i>
                <a [routerLink]="['/edit-document', 9, line.paymentDocumentId]" target="_blank">Платіж №{{line.paymentDocumentId}}</a>
              </span>
              <span *ngSwitchCase="'queued'"><i class="pi pi-spin pi-spinner"></i> Виконується…</span>
              <span *ngSwitchCase="'idle'" class="split-status--muted">Пропущено</span>
              <span *ngSwitchDefault class="split-status--bad"><i class="pi pi-times"></i> {{line.message}}</span>
            </ng-container>
            <div class="split-line-note" *ngIf="line.status === 'created' && line.message">{{line.message}}</div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="phase !== 'edit' ? 10 : 9">
            Відкритих рахунків контрагента не знайдено. Додайте рахунок вручну.
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="split-picker" *ngIf="phase === 'edit'">
      <label class="split-picker-label">Додати інший рахунок</label>
      <ng-container *ngFor="let k of [pickerKey]">
        <app-documentselector showLabel="false" placeholder="Знайти рахунок..."
                              (selectedDocument)="onManualInvoice($event)"
                              [style]="{'width':'100%'}"></app-documentselector>
      </ng-container>
    </div>

    <div class="split-total split-total--{{totalState}}">
      Розподілено <strong>{{validation.allocated | number:'1.2-2'}}</strong>
      з {{row.amount_decimal | number:'1.2-2'}} {{row.currency_code}}
      · Залишок <strong>{{validation.remaining | number:'1.2-2'}}</strong>
      <span class="split-total-error" *ngIf="phase === 'edit' && validation.totalError"> -- {{validation.totalError}}</span>
      <div class="split-total-note" *ngIf="phase === 'edit' && totalState === 'under' && !validation.totalError">
        Нерозподілений залишок лише показується -- він ніде не зберігається.
      </div>
    </div>
  </ng-container>

  <ng-template pTemplate="footer">
    <ng-container *ngIf="phase === 'edit'">
      <p-button label="Скасувати" styleClass="p-button-secondary mr-2" (onClick)="close()"></p-button>
      <p-button label="Внести автоматично" icon="pi pi-bolt" styleClass="p-button-success"
                [disabled]="!canRun" [pTooltip]="firstProblem || ''" [tooltipDisabled]="!firstProblem"
                (onClick)="onRun()"></p-button>
    </ng-container>

    <ng-container *ngIf="phase === 'running'">
      <p-button label="Виконується…" icon="pi pi-spin pi-spinner" [disabled]="true"></p-button>
    </ng-container>

    <ng-container *ngIf="phase === 'result'">
      <p-button label="Повторити решту" icon="pi pi-refresh" styleClass="p-button-warning mr-2"
                *ngIf="retryable.length > 0" (onClick)="onRetryRemaining()"></p-button>
      <p-button label="Закрити" styleClass="p-button-secondary" (onClick)="close()"></p-button>
    </ng-container>
  </ng-template>
</p-dialog>
